import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

import {aemContentApi, sessionApi, accountDetailsApi, lookupDataApi} from './services/apiServices';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [aemContentApi.reducerPath]: aemContentApi.reducer,
    [sessionApi.reducerPath]: sessionApi.reducer,
    [accountDetailsApi.reducerPath]: accountDetailsApi.reducer,
    [lookupDataApi.reducerPath]: lookupDataApi.reducer
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      aemContentApi.middleware,
      sessionApi.middleware,
      accountDetailsApi.middleware,
      lookupDataApi.middleware
    )
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
